import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isExtraCreditsModalOpen: false,
  isCreateVideoModalOpen: false,
  initialContentType: "videos",
  initialStep: "video-type",
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openExtraCreditsModal: (state) => {
      state.isExtraCreditsModalOpen = true;
    },
    closeExtraCreditsModal: (state) => {
      state.isExtraCreditsModalOpen = false;
    },
    openCreateVideoModal: (state, action) => {
      state.isCreateVideoModalOpen = true;
      state.initialContentType = action.payload?.type || "videos";
      state.initialStep = action.payload?.step || "video-type";
      state.initialBrandId = action.payload?.brandId || null;
    },
    closeCreateVideoModal: (state) => {
      state.isCreateVideoModalOpen = false;
    },
  },
});

export const { 
  openExtraCreditsModal, 
  closeExtraCreditsModal, 
  openCreateVideoModal, 
  closeCreateVideoModal 
} = uiSlice.actions;
export default uiSlice.reducer;
